import toggleVisibility from '../toggleVisibility';

const updateSelectedVariant = ({ variant, variantInventory = [], elements = {}, strings = {} }) => {
  const {
    productControls,
    atcButtonMsg,
    optionValueElement
  } = elements;

  const current = variantInventory.find(v => v.id === variant.id);
  const isPreOrder = current && !current.available && current.inventory_policy === 'continue';
  const isSoldOut = !variant.available && !isPreOrder;
  const isAvailable = variant.available;

  if (productControls) toggleVisibility(productControls, isAvailable);

  const getAtcBtnText = () => {
    if (isSoldOut) return strings.soldOut;
    if (isPreOrder) return strings.preOrder;
    return strings.addToCart;
  };

  if (atcButtonMsg) {
    atcButtonMsg.textContent = getAtcBtnText();
  }

  if (optionValueElement) {
    optionValueElement.textContent = variant.title;
  }
};

export default updateSelectedVariant;
